import cloneDeep from 'lodash/cloneDeep';
import { useMainStore } from '../stores/mainStore.js';

export default defineNuxtPlugin(() => {
  const mainStore = useMainStore();
  window.clientWorkState = cloneDeep(mainStore.clientWorkState);
});
